<template>
  <div class="boss-main-container">
    <div class="boss-main-content-wrap">
      <seminar-entry-detail-previous-duplicate
        v-if="recentDuplicatedSeminarEntryId"
        :seminar-id="seminar.id"
        :seminar-name="recentDuplicatedSeminarName"
        :entry-id="recentDuplicatedSeminarEntryId"
        :entry-date="recentDuplicatedSeminarEntryDate"
        data-test="duplicated-info"
      />
      <section>
        <div class="boss-layout-block margin-bottom-0">
          <router-link
            :to="{ name: 'seminarEntryTop' }"
            class="boss-back-to-list-link"
          >
            セミナー応募者一覧
          </router-link>
        </div>
        <div class="boss-layout-block margin-bottom-1">
          <div class="boss-title-wrap">
            <div class="boss-layout boss-layout-gap-between">
              <h1
                class="boss-title-2"
                data-test="label-seminar"
              >
                セミナーID: {{ seminar.id }}
                <br>{{ seminar.name }}
              </h1>
            </div>
          </div>
        </div>
        <div class="boss-layout-block margin-bottom-05">
          <div class="boss-layout boss-layout-gap-between">
            <div class="pega-width-50-percent">
              <div data-test="label-phonetic">
                {{ userPhoneticName }}
              </div>
              <div class="boss-layout boss-layout-start boss-layout-baseline boss-layout-gap-small">
                <div
                  class="boss-entry-name"
                  data-test="label-name"
                >
                  {{ userName }}
                </div>
                <div data-test="label-user-id">
                  （ID:{{ userId }}）
                </div>
                <div>
                  <span
                    v-if="isDuplicatedEntries"
                    v-tooltip="{ content: '同一セミナーに複数回応募している場合に表示されます。'}"
                    class="boss-status-label"
                    data-test="label-duplicated-entries"
                  >重複応募</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="boss-main-content-wrap">
      <div class="boss-layout-block">
        <div>
          <div class="boss-layout-block margin-bottom-1">
            <ul
              id="boss-tab-menu"
              data-tabs
              class="tabs boss-tabs-menu-list"
            >
              <li
                :class="{'is-active': currentTabKey === 'resume'}"
                class="tabs-title"
              >
                <a
                  class="boss-tabs-link"
                  data-test="link-resume"
                  @click="changeCurrent('resume')"
                >
                  <svg
                    class="boss-tabs-link-icon"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g>
                      <path
                        d="M12.5 2.5H7.5H3.75H1.25C0.55625 2.5 0 3.05625 0 3.75V16.25C0 16.9438 0.55625 17.5 1.25 17.5H18.75C19.4438 17.5 20 16.9438 20 16.25V3.75C20 3.05625 19.4438 2.5 18.75 2.5H16.25H12.5ZM16.25 3.75H18.125C18.4688 3.75 18.75 4.03125 18.75 4.375V15.625C18.75 15.9688 18.4688 16.25 18.125 16.25H1.875C1.53125 16.25 1.25 15.9688 1.25 15.625V4.375C1.25 4.03125 1.53125 3.75 1.875 3.75H3.75H7.5H12.5H16.25Z"
                        fill="#bf192c"
                      />
                      <path
                        d="M13.125 9.375H14.375C14.7188 9.375 15 9.09375 15 8.75C15 8.40625 14.7188 8.125 14.375 8.125H13.125C12.7812 8.125 12.5 8.40625 12.5 8.75C12.5 9.09375 12.7812 9.375 13.125 9.375Z"
                        fill="#bf192c"
                      />
                      <path
                        d="M15.625 10.625H13.125C12.7812 10.625 12.5 10.9062 12.5 11.25C12.5 11.5938 12.7812 11.875 13.125 11.875H15.625C15.9688 11.875 16.25 11.5938 16.25 11.25C16.25 10.9062 15.9688 10.625 15.625 10.625Z"
                        fill="#bf192c"
                      />
                      <path
                        d="M8.27492 10.825C8.93742 10.375 9.37492 9.6125 9.37492 8.75C9.37492 7.36875 8.25618 6.25 6.87492 6.25C5.49367 6.25 4.37492 7.36875 4.37492 8.75C4.37492 9.6125 4.81243 10.375 5.47493 10.825C3.69993 11.3687 3.18118 12.85 3.15618 12.9313C3.04993 13.2563 3.22492 13.6125 3.54992 13.7188C3.88117 13.825 4.23117 13.65 4.33742 13.325C4.34992 13.3062 4.84992 11.875 6.87492 11.875C8.86867 11.875 9.38742 13.2687 9.40617 13.325C9.49367 13.5875 9.73742 13.75 9.99992 13.75C10.0624 13.75 10.1312 13.7375 10.1999 13.7188C10.5249 13.6125 10.7062 13.2563 10.5937 12.9313C10.5687 12.85 10.0499 11.3687 8.27492 10.825ZM6.87492 7.5C7.56242 7.5 8.12492 8.0625 8.12492 8.75C8.12492 9.4375 7.56242 10 6.87492 10C6.18742 10 5.62492 9.4375 5.62492 8.75C5.62492 8.0625 6.18742 7.5 6.87492 7.5Z"
                        fill="#bf192c"
                      />
                    </g>
                  </svg>
                  レジュメ
                </a>
              </li>
              <li
                :class="{'is-active': currentTabKey === 'message'}"
                class="tabs-title"
              >
                <a
                  class="boss-tabs-link"
                  data-test="link-message"
                  @click="changeCurrent('message')"
                >
                  <svg
                    class="boss-tabs-link-icon"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.75 0H5C4.30625 0 3.75 0.55625 3.75 1.25V3.75H1.25C0.55625 3.75 0 4.30625 0 5V13.75C0 14.4438 0.55625 15 1.25 15H3.75V18.75C3.75 19.2563 4.05625 19.7125 4.51875 19.9062C4.675 19.9688 4.8375 20 5 20C5.325 20 5.64375 19.875 5.88125 19.6313L10.5188 15H15C15.6938 15 16.25 14.4438 16.25 13.75V11.25H18.75C19.4438 11.25 20 10.6938 20 10V1.25C20 0.55625 19.4438 0 18.75 0ZM15 13.125C15 13.4688 14.7188 13.75 14.375 13.75C14.375 13.75 11.0375 13.75 10.5188 13.75C10 13.75 9.6375 14.1187 9.6375 14.1187L5 18.75V14.375C5 14.0312 4.71875 13.75 4.375 13.75H1.875C1.53125 13.75 1.25 13.4688 1.25 13.125V5.625C1.25 5.28125 1.53125 5 1.875 5H14.375C14.7188 5 15 5.28125 15 5.625V13.125ZM18.75 9.375C18.75 9.71875 18.4688 10 18.125 10H16.25V5C16.25 4.30625 15.6938 3.75 15 3.75H5V1.875C5 1.53125 5.28125 1.25 5.625 1.25H18.125C18.4688 1.25 18.75 1.53125 18.75 1.875V9.375Z"
                      fill="#bf192c"
                    />
                    <path
                      d="M4.375 8.75H7.5C7.84375 8.75 8.125 8.46875 8.125 8.125C8.125 7.78125 7.84375 7.5 7.5 7.5H4.375C4.03125 7.5 3.75 7.78125 3.75 8.125C3.75 8.46875 4.03125 8.75 4.375 8.75Z"
                      fill="#bf192c"
                    />
                    <path
                      d="M11.875 10H4.375C4.03125 10 3.75 10.2812 3.75 10.625C3.75 10.9688 4.03125 11.25 4.375 11.25H11.875C12.2188 11.25 12.5 10.9688 12.5 10.625C12.5 10.2812 12.2188 10 11.875 10Z"
                      fill="#bf192c"
                    />
                  </svg>
                  メッセージ
                </a>
              </li>
            </ul>
          </div>
          <div class="boss-layout-block">
            <keep-alive>
              <component
                :is="tabs[currentTabKey]"
                :entry-id="entryId"
                :is-withdraw="isWithdraw"
                data-test="tab-content"
              />
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.boss-layout-block {
  margin-bottom: 50px;
}
</style>
<script>
import SeminarEntryResume from '@/components/organisms/SeminarEntryResume'
import SeminarEntryMessage from '@/components/organisms/SeminarEntryMessage'
import SeminarEntryDetailPreviousDuplicate from '@/components/organisms/SeminarEntryDetailPreviousDuplicate'
import _ from 'lodash'

export default {
  components: {
    SeminarEntryDetailPreviousDuplicate,
    SeminarEntryResume,
    SeminarEntryMessage
  },
  props: {
    tabKey: {
      type: String,
      default: 'resume'
    }
  },
  data () {
    return {
      entryDate: '',
      userId: '',
      userLastName: '',
      userLastNameKana: '',
      userFirstName: '',
      userFirstNameKana: '',
      seminar: {
        id: null,
        name: '...'
      },
      isWithdraw: false,
      isDuplicatedEntries: false,
      recentDuplicatedSeminarEntryId: null,
      recentDuplicatedSeminarEntryDate: '',
      recentDuplicatedSeminarName: '',
      currentTabKey: this.tabKey,
      tabs: {
        resume: 'seminar-entry-resume',
        message: 'seminar-entry-message'
      },
      entryId: Number(this.$route.params.entryId)
    }
  },
  computed: {
    userName () {
      return this.userLastName + ' ' + this.userFirstName
    },
    userPhoneticName () {
      return this.userLastNameKana + ' ' + this.userFirstNameKana
    }
  },
  watch: {
    $route: {
      handler (val) {
        this.fetchEntry()
        this.$set(this, 'entryId', Number(val.params.entryId))
      }
    }
  },
  created () {
    this.fetchEntry()
  },
  methods: {
    fetchEntry () {
      this.$http.secured.get(`/seminar/entries/${this.$route.params.entryId}`).then(response => {
        this.$set(this, 'entryDate', _.get(response.data, 'entryDate', ''))
        this.$set(this, 'userId', _.get(response.data, 'userId', ''))
        this.$set(this, 'userLastName', _.get(response.data, 'userLastName', ''))
        this.$set(this, 'userLastNameKana', _.get(response.data, 'userLastNameKana', ''))
        this.$set(this, 'userFirstName', _.get(response.data, 'userFirstName', ''))
        this.$set(this, 'userFirstNameKana', _.get(response.data, 'userFirstNameKana', ''))
        this.$set(this, 'seminar', _.get(response.data, 'seminar', {
          id: null,
          name: ''
        }))
        this.$set(this, 'isWithdraw', _.get(response.data, 'isWithdrawal', false))
        this.$set(this, 'isDuplicatedEntries', _.get(response.data, 'isDuplicatedEntries', false))
        this.$set(this, 'recentDuplicatedSeminarEntryId', _.get(response.data, 'recentDuplicatedSeminarEntryId', null))
        this.$set(this, 'recentDuplicatedSeminarEntryDate', _.get(response.data, 'recentDuplicatedSeminarEntryDate', ''))
        this.$set(this, 'recentDuplicatedSeminarName', _.get(response.data, 'recentDuplicatedSeminarName', ''))
      })
    },
    changeCurrent (key) {
      this.$set(this, 'currentTabKey', key)
    }
  }
}
</script>
